import { render } from "./addRoom.vue?vue&type=template&id=2fc7dde7&scoped=true"
import script from "./addRoom.vue?vue&type=script&lang=js"
export * from "./addRoom.vue?vue&type=script&lang=js"

import "./addRoom.vue?vue&type=style&index=0&id=2fc7dde7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc7dde7"]])

export default __exports__